import { api, type Items } from '@sentinel/web-core';
import type { PlatformAccessGrant, TokenGrant } from '@sentinel/shared';

export interface OrganizationSummary {
  id: string;
  slug: string;
  name: string;
  kind: string;
}

export const platformEndpoints = {
  organizations: () => api<Items<OrganizationSummary>>('/platform/organizations'),
  requests: () => api<Items<PlatformAccessGrant>>('/platform/access-requests'),
  request: (organizationId: string, reason: string) =>
    api<PlatformAccessGrant>('/platform/access-requests', {
      method: 'POST',
      body: { organizationId, reason },
    }),
  enter: (grantId: string) =>
    api<TokenGrant>(`/platform/access-requests/${grantId}/enter`, { method: 'POST' }),
  close: (grantId: string) =>
    api<PlatformAccessGrant>(`/platform/access-requests/${grantId}/close`, { method: 'POST' }),
  organizationGrants: () => api<Items<PlatformAccessGrant>>('/platform-access'),
  approve: (grantId: string, hours?: number) =>
    api<PlatformAccessGrant>(`/platform-access/${grantId}/approve`, {
      method: 'POST',
      body: { hours },
    }),
  deny: (grantId: string) =>
    api<PlatformAccessGrant>(`/platform-access/${grantId}/deny`, { method: 'POST' }),
  revoke: (grantId: string) =>
    api<PlatformAccessGrant>(`/platform-access/${grantId}/revoke`, { method: 'POST' }),
};
